var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details"},_vm._l((_vm.details),function(detail,index){return _c('detail-item',{key:("detail_" + index),attrs:{"detail":detail}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }